<template>
  <div>
    <div class="main-button-bar">
      <el-button type="primary" size="small" @click="showAddDialog">新增店铺</el-button>
    </div>

    <el-table
      :data="records"
      stripe
      style="width: 100%"
      :height="this.$tools.mainHeight() - 84"
      class="taobao-stop-table"
    >
      <el-table-column prop="name" label="店铺名称" width="200"></el-table-column>
      <el-table-column prop="type" label="店铺类型" width="100">
        <template slot-scope="shop">
          <el-tag type="success" v-if="shop.row.type == 'B'">天猫</el-tag>
          <el-tag type="info" v-if="shop.row.type == 'C'">淘宝</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="shop">
          <el-tag type="success" v-if="shop.row.status == 'Y'">可用</el-tag>
          <el-tag type="danger" v-if="shop.row.status == 'N'">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="secret" label="秘钥" width="500"> </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="shop">
          <el-button v-if="shop.row.status == 'Y'" type="text" size="small" v-on:click="upstatus(shop.row.id, 'N')">禁用</el-button>
          <el-button v-if="shop.row.status == 'N' || !shop.row.status" type="text" size="small" v-on:click="upstatus(shop.row.id, 'Y')">启用</el-button>
          <el-button type="text" size="small" v-on:click="upsecret(shop.row.id)">修改秘钥</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="shop && shop.id ? '修改店铺' : '新增店铺'" :visible.sync="showDialog" width="500px">
      <el-form ref="shop" :model="shop" label-width="60px" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="shop.name"></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-select v-model="shop.type" placeholder="请选择类型" style="width:100%">
            <el-option label="天猫" value="B"></el-option>
            <el-option label="淘宝" value="C"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="秘钥" prop="secret">
          <el-input v-model="shop.secret"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" class="op-button" @click="doAdd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      records: null,
      shop: {},
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 6 个字符",
            trigger: "blur",
          },
        ],
        secret: [{ required: true, message: "请输入私钥", trigger: "blur" }],
      },
    };
  },
  methods: {
    showAddDialog() {
      this.shop = {};
      this.showDialog = true;
    },
    doAdd() {
      let _this = this;

      _this.$http.post(
        ["taobao/shop/save", _this.shop],
        [
          function () {
            _this.showDialog = false;
            _this.shop = {};
            _this.list();
          },
        ],
        ".op-button"
      );
    },

    list() {
      let _this = this;

      _this.$http.post(
        ["taobao/shop/list"],
        [
          function (data) {
            _this.records = data;
          },
        ],
        ".taobao-stop-table"
      );
    },

    upstatus(id, status) {
      this.shop.id = id;
      this.shop.status = status;
      this.doAdd();
    },

    upsecret(id) {
      let _this = this;

     

      _this.$tPrompt.show("输入新秘钥", function(data) {
         _this.shop.id = id;
        _this.shop.secret = data;
        _this.doAdd();
      })
    }
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss">
</style>